<template>
	<el-row>
		<el-button @click="add()">添加素材+</el-button>
		<el-row>
			<el-col>
				<span>素材搜索</span>
				<el-col :span="6" style="margin: 0 10px;">
					<el-input v-model="festivalName"></el-input>
				</el-col>
				<el-col :span="6">
					<el-select v-model="dataTypes" placeholder="请选择类型" style="width: 100%;">
						<el-option label="老板分享" value="1"></el-option>
						<el-option label="社群分享" value="2"></el-option>
						<el-option label="进货见闻" value="3"></el-option>
						<el-option label="一点就通" value="4"></el-option>
					</el-select>
				</el-col>
				<el-button @click="query()" type="primary">筛选</el-button>
				<!-- <el-button @click="Export()" type="warning">导出Excel</el-button> -->
				<el-button @click="reset()" type="success">重置</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<el-table :data="tableData">
					<el-table-column label="序号" prop="id" width="50px"></el-table-column>
					<!-- <el-table-column label="年份" prop="year"></el-table-column> -->
					<el-table-column label="素材名称" prop="festivalName"></el-table-column>
					<el-table-column label="类型">
						<template slot-scope="scope">
							<p v-if="scope.row.dataType == 1">老板分享</p>
							<p v-if="scope.row.dataType == 2">社群分享</p>
							<p v-if="scope.row.dataType == 3">进货见闻</p>
							<p v-if="scope.row.dataType == 4">一点就通</p>
						</template>
					</el-table-column>
					<el-table-column label="圈文素材">
						<template slot-scope="scope">
							{{scope.row.qw.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<el-table-column label="视频">
						<template slot-scope="scope">
							{{scope.row.sp.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<el-table-column label="图片">
						<template slot-scope="scope">
							{{scope.row.hb.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<!-- <el-table-column label="节日款商品">
						<template slot-scope="scope">
							{{scope.row.jrksp.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<el-table-column label="节日活动" prop="">
						<template slot-scope="scope">
							{{scope.row.jrhd.length>0 ?"有" :"无"}}
						</template>
					</el-table-column> -->
					<!-- <el-table-column label="商品主图">
						<template slot-scope="scope">
							{{scope.row.spzt.length>0 ?"有" :"无"}}
						</template>
					</el-table-column> -->
					<el-table-column label="创建时间" prop="createTime"></el-table-column>
					<el-table-column label="更新时间" prop="updateTime"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="editor(scope.row)" type="text" size="mini" style="color: #a6e22e;">编辑
							</el-button>
							<el-button @click="toView(scope.row)" type="text" size="mini">查看</el-button>
							<el-button @click="del(scope.row)" type="text" size="mini" style="color: red;">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30,60,100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="dialogVisible" center width="30%">
			<el-form ref="info" :model="info" label-position="right" label-width="100px">
				<el-form-item label="类型" prop="dataTypes" :rules="[{
					 required: true, message: '请选择类型', trigger: 'blur'
				}]">
					<el-radio-group v-model="info.dataTypes">
						<el-radio :label="1">老板分享</el-radio>
						<el-radio :label="2">社群分享</el-radio>
						<el-radio :label="3">进货见闻</el-radio>
						<el-radio :label="4">一点就通</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="素材名称" prop="festivalName" :rules="[{
					 required: true, message: '请输入素材名称', trigger: 'blur'
				}]">
					<el-input v-model="info.festivalName"></el-input>
				</el-form-item>
				<el-form-item label-width="200px">
					<el-button type="infor" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submit">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				festivalName: '',
				total: 0,
				pageNum: 1,
				pageSize: 30,
				dialogVisible: false,
				dataTypes: null,
				title: '',
				info: {
					id: '',
					year: '',
					festivalName: '',
					dataTypes: ''
				}
			}
		},
		methods: {
			//添加
			add() {
				this.dialogVisible = true
				this.info.year = ''
				this.info.festivalName = ''
				this.info.dataTypes = null
				this.title = '添加素材'
			},
			//查询
			query() {
				this.getList()
			},
			//导出
			Export() {
				this.$http.post(`/api/statistics/knowledgeBase/exportFestival`, {
					festivalName: this.festivalName,
					dataType: 1
				}, {
					responseType: 'blob'
				}).then(res => {
					console.log(res);
					this.$message({
						type: 'info',
						message: '正在导出素材表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '素材列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			reset() {
				this.festivalName = ''
				this.info.dataTypes = null
				this.getList()
			},
			//确认
			submit() {
				console.log(this.info);
				this.$refs.info.validate((valid) => {
					if (valid) {
						switch (this.title) {
							case '添加素材': {
								this.$http.post('/api/plant/knowledgeBase/insertFestival', {
									"year": '', //年份
									"festivalName": this.info.festivalName, //节日名称
									"dataType": this.info.dataTypes,
								}).then(res => {
									console.log(res.data);
									if (res.data.status == 0) {
										this.$message.success(res.data.data)
										this.dialogVisible = false
										this.getList()
									} else {
										this.$message.error('素材名称已存在,请修改后重新添加')
									}
								})
								break
							}
							case '编辑素材': {
								this.$http.post('/api/plant/knowledgeBase/updateFestival', {
									"id": this.info.id,
									"year": '', //年份
									"festivalName": this.info.festivalName, //节日名称
									"dataType": this.info.dataTypes,
								}).then(res => {
									console.log(res.data);
									if (res.data.status == 0) {
										this.$message.success(res.data.data)
										this.dialogVisible = false
										this.getList()
									} else {
										this.$message.error('素材名称已存在,请修改后重新添加')
									}
								})
								break
							}
						}
					} else {
						return false
					}
				})
			},
			//编辑
			editor(row) {
				console.log(row);
				this.title = '编辑素材'
				this.dialogVisible = true
				this.info = {
					id: row.id,
					year: row.year,
					festivalName: row.festivalName,
					dataTypes: row.dataType
				}
			},
			//删除
			del(row) {
				this.$confirm('此操作将永久删除该素材, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/knowledgeBase/updateFestival', {
						"id": row.id,
						"deleteStatus": 1
					}).then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.success('删除成功')
							this.getList()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//查看
			toView(row) {
				this.$router.push({
					path: '/shareDetails',
					query: {
						id: row.id,
						year: row.year,
						festivalName: row.festivalName
					}
				})
			},
			//获取列表
			getList() {
				this.$http.post('/api/plant/knowledgeBase/selectFestival', {
					"festivalName": this.festivalName,
					"dataType": null,
					"dataTypes": this.dataTypes ? [this.dataTypes] : [1, 2, 3, 4],
					"pageNum": this.pageNum,
					"pageSize": this.pageSize
				}).then(res => {
					let newData = res.data.data.list
					if (newData.length > 0) {
						console.log(newData[0]);
						newData.forEach(item => {
							item.qw = []
							item.sp = []
							item.hb = []
							item.jrksp = []
							item.jrhd = []
							item.spzt = []
							if (item.festivalCommodityVos.length > 0) {
								item.festivalCommodityVos.forEach(i => {
									item.jrksp.push(i)
								})
							}
							if (item.paragraphVos.length > 0) {
								item.paragraphVos.forEach(i => {
									if (i.paragraphType == "03") {
										item.qw.push(i)
									}
								})
							}
							if (item.materialPicVos.length > 0) {
								item.materialPicVos.forEach(i => {
									if (i.materialType == "04") {
										item.sp.push(i)
									}
									if (i.materialType == "03") {
										item.hb.push(i)
									}
									if (i.materialType == "02") {
										item.spzt.push(i)
									}
								})
							}
						})
					}
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getList()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getList()
			},
		},
		created() {
			this.getList()
		}
	}
</script>

<style scoped>
</style>
